import { render, staticRenderFns } from "./EixoXFlutuante.vue?vue&type=template&id=6a6b7f96&scoped=true&"
import script from "./EixoXFlutuante.vue?vue&type=script&lang=js&"
export * from "./EixoXFlutuante.vue?vue&type=script&lang=js&"
import style0 from "./EixoXFlutuante.vue?vue&type=style&index=0&id=6a6b7f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6b7f96",
  null
  
)

export default component.exports